import * as React from 'react';

function FreeBet(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18" {...props}>
      <path d="M17.867 18H0L3.133 0H21l-3.133 18z" fill="#007AB8" />
      <path
        d="M11.371 8.125l-.685.349-.546-.546.122.764-.69.354.763.122.122.764.346-.69.763.118-.546-.546.351-.69z"
        fill="white"
      />
      <path
        d="M16.16 5.012a1.197 1.197 0 01-1.7 0 1.219 1.219 0 010-1.711l-1.789-1.804-9.616 9.688 1.79 1.803a1.197 1.197 0 011.699 0c.468.472.468 1.24 0 1.712l1.79 1.803 9.615-9.688-1.79-1.803zm-4.702 5.693a.876.876 0 01-1.469-.834.084.084 0 00-.026-.074c-.03-.03-.083-.04-.109-.009-.16.21-.511.773-.255 1.34L8.389 9.91c.564.258 1.123-.096 1.331-.257.03-.027.026-.079-.009-.11-.021-.021-.047-.026-.073-.026a.871.871 0 01-.828-.231.887.887 0 010-1.249c.516-.52 1.5-.567 1.915-.567.79 0 1.287.009 1.287.009s.01.502.01 1.296c-.005.42-.053 1.41-.564 1.93z"
        fill="white"
      />
    </svg>
  );
}

export default FreeBet;
